/* eslint-disable react-hooks/exhaustive-deps */
import {
	Box,
	Button,
	Flex,
	Modal,
	ModalBody,
	ModalCloseButton,
	ModalContent,
	ModalHeader,
	ModalOverlay,
	SimpleGrid,
	Text,
	useDisclosure,
} from '@chakra-ui/react';
import { faSlidersH } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Form, Formik } from 'formik';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import * as Yup from 'yup';
import CheckboxGroupFormField from '../../../components/form/CheckboxGroupFormField';
import SelectValueFormField from '../../../components/form/SelectValueFormField';
import c from '../../../constant';
import useStore from '../../../store';
import { EWSTypeStatement } from '../../../utils/ews';
import { mappingKhmerNumber } from '../../../utils/market-development';
import EwsSummaryCompanyFormField from './ews-summary-company-field';
import EwsSummaryCompanyTypeFormField from './ews-summary-company-type-field';

const validationSchema = Yup.lazy((values) =>
	Yup.object({
		year: Yup.string().nullable(),
		quarters: Yup.array()
			.of(Yup.string().oneOf(['Quarter1', 'Quarter2', 'Quarter3', 'Quarter4'], 'invalid').required('required'))
			.nullable(),
		companyType: Yup.string().oneOf(['1', '2', '3', '4', '5'], 'invalid').nullable(),
		...(false === values?.industrial
			? {
					companyId: Yup.string().nullable(),
				}
			: {}),
	}),
);

export default function EwsQuarterSummaryFilter({
	industrial = false,
	reportId = null,
	report = null,
	companyType = null,
	companyId = null,
	quarters = null,
	year = null,
	onCallback = () => null,
}) {
	const { t } = useTranslation();
	const { isOpen, onOpen, onClose } = useDisclosure();
	const { currentLang: lang } = useStore((state) => state?.currentLang);

	return (
		<>
			<Button
				isLoading={false}
				isDisabled={false}
				onClick={onOpen}
				leftIcon={<FontAwesomeIcon icon={faSlidersH} style={{ fontSize: 16 }} />}
				colorScheme={companyType || companyId || year || quarters ? 'yellow' : 'gray'}
				variant="solid"
				size="sm"
				borderRadius={c.borderRadius}
				border="1px solid #bdc3c7"
			>
				<Text fontSize="sm" fontWeight="semibold">
					{t('Filter')}
				</Text>
			</Button>
			<Modal borderRadius={c.borderRadius} isOpen={isOpen} onClose={onClose}>
				<ModalOverlay />
				<ModalContent borderRadius={c.borderRadius}>
					<ModalHeader>{t('Filter')}</ModalHeader>
					<ModalCloseButton />
					<ModalBody>
						<Formik
							validationSchema={validationSchema}
							initialValues={{
								industrial,
								quarters: quarters ? JSON.parse(quarters) : [],
								year: year ?? '',
								companyType: companyType ?? '',
								companyId: companyId ?? '',
							}}
							onSubmit={(values) => {
								let url = '?period=quarterly&reportId=' + reportId + '&report=' + report;
								if (values?.companyType) {
									url = url + `&companyType=${values?.companyType}`;
								}
								if (values?.companyId) {
									url = url + `&companyId=${values?.companyId}`;
								}
								if (values?.year) {
									url = url + `&year=${values?.year}`;
								}
								if (values?.quarters?.length > 0) {
									url = url + `&quarters=${JSON.stringify(values?.quarters)}`;
								}
								onCallback(url);
								onClose();
							}}
						>
							{({ values, ...props }) => {
								return (
									<Box pb="4">
										<Form>
											<SimpleGrid columns={1} spacing={4}>
												<EwsSummaryCompanyTypeFormField
													{...props}
													name="companyType"
													label="Company Type"
													formNameCompanyId="companyId"
													placeholder={t('Company Type')}
													industrial={industrial}
												/>
												{false === values?.industrial && (
													<>
														<EwsSummaryCompanyFormField
															{...props}
															name="companyId"
															label="Company"
															formNameCompanyType="companyType"
															industrial={industrial}
														/>
													</>
												)}
												<CheckboxGroupFormField
													{...props}
													name="quarters"
													label="Quarters"
													options={[
														{ label: t('q1'), value: EWSTypeStatement.q1 },
														{ label: t('q2'), value: EWSTypeStatement.q2 },
														{ label: t('q3'), value: EWSTypeStatement.q3 },
														{ label: t('q4'), value: EWSTypeStatement.q4 },
													]}
												/>
												<SelectValueFormField
													{...props}
													placeholder={t('Year')}
													name="year"
													label="Year"
													options={[0].reduce((p, c) => {
														let lp = p;
														let i = 2021;
														while (i <= moment().year()) {
															lp.push({ label: lang === 'kh' ? mappingKhmerNumber(i) : i, value: i });
															i = i + 1;
														}
														return lp?.reverse();
													}, [])}
												/>
												<Flex mt={2} justifyContent="flex-end">
													<Button
														mr={2}
														colorScheme="gray"
														variant="solid"
														size="md"
														h="42px"
														w="128px"
														borderRadius={c.borderRadius}
														onClick={() => {
															let url = '?period=quarterly&reportId=' + reportId + '&report=' + report;
															onCallback(url);
															onClose();
														}}
													>
														{t('Clear')}
													</Button>
													<Button
														ml={2}
														colorScheme="blue"
														variant="solid"
														size="md"
														h="42px"
														w="128px"
														type="submit"
														borderRadius={c.borderRadius}
													>
														{t('Apply')}
													</Button>
												</Flex>
											</SimpleGrid>
										</Form>
									</Box>
								);
							}}
						</Formik>
					</ModalBody>
				</ModalContent>
			</Modal>
		</>
	);
}
